import { useState, type FC } from 'react';

import { Space, Text } from '@g2u/ui-kit';
import { Select } from 'antd';

import { useJobTickets } from '../hooks/useJobTickets';
import styles from '../edit.module.scss';
import { CreateTicketModal, TicketList } from 'components';

type Props = Readonly<{
  jobId?: string;
}>;

export const JobTickets: FC<Props> = (props) => {
  const { jobId } = props;
  const [status, setStatus] = useState<'0' | '1' | null>(null);
  const { tickets, paginationMetadata, isTicketsLoading } = useJobTickets(status, jobId);

  const [isCreateModalOpen, setCreateModalOpen] = useState<boolean>();

  return (
    <>
      <title>Job Tickets</title>
      <Space.$
        direction={Space.Direction.Vertical}
        size={Space.Size.ExtraLarge}
        fullWidth
        className={styles.jobEdit__content}
      >
        <Space.$ justify={Space.Justify.SpaceBetween}>
          <span>
            <Text.$>Status : </Text.$>
            <Select
              style={{ width: 150 }}
              defaultValue={null}
              options={[
                {
                  label: 'All',
                  value: null,
                },
                {
                  label: 'Open',
                  value: '1',
                },
                {
                  label: 'Closed',
                  value: '0',
                },
              ]}
              onChange={(val) => setStatus(val)}
            />
          </span>
        </Space.$>
        <TicketList
          tickets={tickets}
          paginationMetadata={paginationMetadata}
          isLoading={isTicketsLoading}
          onAdd={() => setCreateModalOpen(true)}
          hideColumns={['customer']}
        />
      </Space.$>
      <CreateTicketModal jobId={jobId} isOpen={!!isCreateModalOpen} onClose={() => setCreateModalOpen(false)} />
    </>
  );
};
